// components
import {
  CButton,
  CFormTextarea
} from '@coreui/react-pro';
import { Send, X } from 'lucide-react';

const AppModalSendFilePreview = ({
  handleClosePreviewModal,
  previewFile,
  previewType,
  fileCaption,
  setFileCaption,
  handleSendFile
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Modal Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 20px',
          backgroundColor: '#202c33'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={handleClosePreviewModal}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X size={24} />
          </button>
          <div>
            <div style={{ color: 'white', fontSize: '16px', fontWeight: '500' }}>
              {previewFile?.name}
            </div>
            <div style={{ color: '#8696a0', fontSize: '13px' }}>
              {previewFile?.size}
            </div>
          </div>
        </div>
      </div>

      {/* Modal Content */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          overflow: 'auto'
        }}
      >
        {previewType === 'image' ? (
          <img
            src={previewFile?.preview}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        ) : previewType === 'video' ? (
          <video
            src={previewFile?.preview}
            controls
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        ) : (
          <div
            style={{
              backgroundColor: '#202c33',
              borderRadius: '12px',
              padding: '40px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px',
              maxWidth: '400px'
            }}
          >
            {/* Document Icon */}
            <div
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                backgroundColor: '#5f66cd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <svg width="60" height="60" viewBox="0 0 24 24" fill="white">
                <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"/>
                <path d="M14 2V8H20" opacity="0.3"/>
              </svg>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div
                style={{
                  color: 'white',
                  fontSize: '18px',
                  fontWeight: '500',
                  marginBottom: '8px',
                  wordBreak: 'break-word'
                }}
              >
                {previewFile?.name}
              </div>
              <div style={{ color: '#8696a0', fontSize: '14px' }}>
                {previewFile?.size}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modal Footer - Caption Input */}
      <div
        style={{
          backgroundColor: '#202c33',
          padding: '16px 20px',
          borderTop: '1px solid #2a3942'
        }}
      >
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <CFormTextarea
              placeholder="Add a caption..."
              value={fileCaption}
              onChange={(e) => setFileCaption(e.target.value)}
              rows={1}
              style={{
                backgroundColor: '#2a3942',
                border: 'none',
                borderRadius: '8px',
                padding: '10px 12px',
                fontSize: '15px',
                color: 'white',
                resize: 'none',
                maxHeight: '100px',
                overflow: 'auto'
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSendFile();
                }
              }}
            />
          </div>
          <CButton
            onClick={handleSendFile}
            style={{
              backgroundColor: '#25d366',
              border: 'none',
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <Send size={20} color="white" />
          </CButton>
        </div>
      </div>
    </div>
  )
}

export default AppModalSendFilePreview;